import { useState, useEffect } from 'react';
import { CONFIG_CDN_URL } from '../constants';
import {onReportEvent} from "../../../cardCapture/utils";
import {SDK_EVENT_KEYS} from "../../../../utils/logService";

export const useConfig = (clientId) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                onReportEvent(SDK_EVENT_KEYS.GetUIConfigInit).catch()
                const url = `${CONFIG_CDN_URL}/${clientId}/Liveness/configV8.json`;
                const res = await fetch(url);
                console.log('configV8 fetch status:', res.status, res.ok);
                if (res.ok) {
                    onReportEvent(SDK_EVENT_KEYS.GetUIConfigSuccess).catch()
                    setConfig(await res.json());
                    setSuccess(true)
                } else {
                    console.log('configV8 fetch failed with status:', res.status);
                }
            } catch (e) {
                console.log('error', e);
                onReportEvent(SDK_EVENT_KEYS.GetUIConfigError).catch()
                setSuccess(false)
            }
            finally {
                setLoading(false);
            }
        };
        fetchConfig();
    }, [clientId]);

    return { config, loading, success };
};
